module.exports = __webpack_public_path__ + "static/media/analysis-macrovector-02-b 7.21bed9a8.png";